<template>
  <div class="upload" draggable>
    <div
      class="pic-upload"
      :contenteditable="url === ''"
      @paste="paste"
      v-loading="imgLoading"
      @drop="drop"
    >
      <img :src="url" v-show="url && acceptType === 'image'" ref="image" />
      <mu-button
        fab
        color="red"
        class="delete-button"
        small
        @click="remove"
        v-if="url"
      >
        <mu-icon value="clear"></mu-icon>
      </mu-button>
      <div class="placeholder" v-else>{{ title }}</div>
      <div class="progress" v-if="imgLoading">
        {{ progress }}
      </div>
    </div>
  </div>
</template>

<script>
import backend from 'utils/backend'
export default {
  props: {
    api: {
      type: Object
    },
    acceptType: {
      type: String,
      default: 'image'
    },
    title: {
      type: String,
      default: '将图片复制或拖动至此处'
    },
    url: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      imgLoading: false,
      progress: '0%'
    }
  },
  methods: {
    drop(e) {
      e.preventDefault()
      const items = e.dataTransfer.files
      let file = null
      if (items && items.length) {
        // 检索剪切板items
        for (let i = 0; i < items.length; i++) {
          if (items[i].type.indexOf(this.acceptType) !== -1) {
            file = items[i]
            break
          }
        }
      }
      if (file !== null) {
        this.picUpload(file)
      } else {
        this.$toast.error('文件选择错误,上传失败')
      }
    },
    paste(e) {
      e.preventDefault()
      const items = event.clipboardData && event.clipboardData.items
      let file = null
      if (items && items.length) {
        // 检索剪切板items
        for (let i = 0; i < items.length; i++) {
          if (items[i].type.indexOf(this.acceptType) !== -1) {
            file = items[i].getAsFile()
            break
          }
        }
      }
      if (file !== null) {
        this.picUpload(file)
      } else {
        this.$toast.error('文件选择错误,上传失败')
      }
    },
    picUpload(file) {
      this.imgLoading = true
      const formData = new FormData()
      formData.append('file', file)
      backend(this.api, formData, (progressEvent) => {
        this.progress =
          ((progressEvent.loaded / progressEvent.total) * 100).toFixed(2) + '%'
      }).then((result) => {
        this.imgLoading = false
        if (result.statusCode === 200) {
          this.$emit('complete', result.data)
        }
      })
    },
    remove() {
      this.$emit('remove')
    }
  }
}
</script>

<style lang="less" scoped>
.upload {
  width: 100%;
  .pic-upload {
    width: 100%;
    height: 200px;
    border: 2px dashed #ddd;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    outline: none;
    .delete-button {
      position: absolute;
      top: 0px;
      right: 0px;
    }
    img {
      max-width: 100%;
      max-height: 100%;
    }
    .progress {
      position: absolute;
      bottom: 20px;
      font-size: 30px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/fileUpload/index.vue